






















import { defineComponent } from "@vue/composition-api";
import { getMediaDuration } from "@scrile/tools/dist/lib/TimeHelpers";
import { StoryFeed } from "@/types";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "StorySubscribeView",
  methods: { getMediaDuration },
  components: { BaseIcon, BaseButton },
  props: {
    story: { required: true, type: Object as () => StoryFeed },
  },
});
